import React, { Component } from 'react';
import { array, number, shape, string } from 'prop-types';

import Desktop from './Desktop/Desktop';
import Mobile from './Mobile/Mobile';

import Css from './faq.scss';

class Screen extends Component {
  static propTypes = {
    faqData: shape({
      className: string.isRequired,
      faqItems: array.isRequired,
      id: string.isRequired,
      mainContent: shape({
        content: string.isRequired,
        header: string.isRequired,
        id: number.isRequired
      })
    }),
    screenHeight: number.isRequired
  };

  renderQuestions = faqItems => {
    return (
      <div key={1} className={Css['questions']}>
        {faqItems.map(function(item) {
          const { content, header, id } = item;
          const subHeader = item.subHeader ? item.subHeader : '';
          const question = (
            <div key={id}>
              <div>
                <span className={'asap-bold'}>{header}</span>
                {subHeader && (
                  <div>
                    <strong>{subHeader}</strong>
                  </div>
                )}
              </div>
              <ul className={Css['answer-items']}>
                {content.map(function(lineItem, index) {
                  return <li key={index}>{lineItem}</li>;
                })}
              </ul>
            </div>
          );

          return question;
        })}
      </div>
    );
  };

  render() {
    const { faqData, screenHeight, heightSm } = this.props;
    const { className, id, faqItems, mainContent } = faqData;
    const isMobile = window.innerWidth < 992;

    let styles = {};

    isMobile
      ? (styles.minHeight = `${screenHeight}px`)
      : (styles.height = `${screenHeight}px`);

    const questions = this.renderQuestions(faqItems);

    return (
      <div
        id={id}
        className={isMobile ? `${className} flex-column` : className}
        style={styles}
      >
        {isMobile ? (
          <Mobile
            mainContent={mainContent}
            questions={questions}
            screenHeight={screenHeight}
          />
        ) : (
          <Desktop
            mainContent={mainContent}
            questions={questions}
            screenHeight={screenHeight}
            heightSm={heightSm}
          />
        )}
      </div>
    );
  }
}

export default Screen;



// WEBPACK FOOTER //
// ./src/components/FAQ/Screen.jsx